export const SET_DATASPACES = 'SET_DATASPACES';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_SELECTED_DATASPACE = 'SET_SELECTED_DATASPACE';
export const SET_MY_DATASPACES = 'SET_MY_DATASPACES';
export const SET_MY_SELECTED_DATASPACE = 'SET_MY_SELECTED_DATASPACE';
export const UPDATE_MY_DATASPACES = 'UPDATE_MY_DATASPACES';
export const SET_DATASPACE_CONNECTOR = 'SET_DATASPACE_CONNECTOR';
